import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "content",
  id: "ask-dialog"
}
const _hoisted_2 = { class: "content-title flex-col-ter" }
const _hoisted_3 = { class: "content-title--1" }
const _hoisted_4 = { class: "content-title--2" }
const _hoisted_5 = { class: "questions" }
const _hoisted_6 = { style: {"overflow":"auto","max-height":"430px","padding":"20px"} }
const _hoisted_7 = {
  class: "flex-ter",
  style: {"margin-bottom":"5px"}
}
const _hoisted_8 = {
  class: "question-title",
  style: {"width":"600px"}
}
const _hoisted_9 = { style: {"margin-left":"20px"} }
const _hoisted_10 = {
  key: 1,
  style: {"text-align":"right","color":"#EB4545"}
}
const _hoisted_11 = { style: {"height":"30px"} }
const _hoisted_12 = {
  class: "flex-col-cen-ter question-submit",
  style: {"height":"108px"}
}

import { t } from '@/plugins/i18n'
import { ElMessage } from 'element-plus'
import { reactive, ref } from 'vue'
import { closeAutoQuest } from '@/apis/usercenter'

export default /*#__PURE__*/_defineComponent({
  props: {
    visible: { type: Boolean, required: true }
  },
  emits: ["close", "submit"],
  setup(__props: any, { emit }: { emit: ({(e: 'close'): void, (e: 'submit'): void }), expose: any, slots: any, attrs: any }) {




const loading = ref(false)
const questions: { show: () => boolean, require: boolean, propName: string, title: string, options: { text: string | null, checked: boolean, requireCustom?: boolean | 'anim', custom?: string, placehodler?: string }[] }[] = reactive([
  {
    show: () => true,
    require: true,
    propName: '',
    title: t('取消自动缴纳会费的原因（可多选）'),
    options: [
      { text: t('我想按照自己的节奏使用会员服务'), checked: false },
      { text: t('我想更改会员费支付方式'), checked: false },
      { text: t('我对会员费自动缴费服务功能不满意（焦虑）'), checked: false, custom: '' },
      { text: t('我想取消乘坐直飞航班'), checked: false },
      { text: t('其他的'), checked: false, custom: '', requireCustom: true, placehodler: t('请填写') }
    ]
  },
  {
    show: () => questions[0].options.some((v, i) => i === 3 && v.checked),
    require: true,
    propName: '',
    title: t('请告诉我们您选择“我想取消直飞航班”的原因（可多选）'),
    options: [
      { text: t('不常使用'), checked: false },
      { text: t('昂贵的'), checked: false, custom: '' },
      { text: t('系统可操作性差'), checked: false, custom: '' },
      { text: t('对运送速度不满意'), checked: false, custom: '' },
      { text: t('对产品质量不满意'), checked: false, custom: '' },
      { text: t('我对支持和询问的答复不满意'), checked: false, custom: '' },
      { text: t('我没有得到我想要的服务'), checked: false, custom: '', placehodler: t('如果您想使用任何其他服务，请告知我们。') },
      { text: t('其他的'), checked: false, custom: '', requireCustom: true, placehodler: t('请填写') }
    ]
  },
  {
    show: () => true,
    require: false,
    propName: '',
    title: t('如果您还有其他意见或要求，请随时填写。'),
    options: [
      { text: '', checked: true, custom: '', placehodler: t('请填写') }
    ]
  }
])

const valid = async () => {
  loading.value = true
  let isWarning = false
  questions.forEach(v => {
    if (v.require && v.show()) {
      // 每一条选项是否选择
      let isCheck = false
      let can = false
      // 每个问题的选项至少选一个，且其他选项必填内容
      v.options.forEach(v2 => {
        if (v2.checked) {
          if ((!v2.requireCustom) || v2.custom) {
            can = true
          } else if (v2.requireCustom && !v2.custom) {
            can = false
            v2.requireCustom = 'anim'
            setTimeout(() => {
              v2.requireCustom = true
            }, 3000)
          }
          isCheck = true
        }
      })
      if (!can || !isCheck) {
        v.propName = 'show'
        isWarning = true
      } else {
        v.propName = ''
      }
    }
  })
  if (!isWarning) {
    const json = questions.map(v => {
      if (v.show()) {
        return {
          title: v.title,
          answer: v.options.filter(v => v.checked).map(v => {
            return {
              text: v.text,
              custom: v.custom
            }
          })
        }
      }
    }).filter(v => v)
    await closeAutoQuest(JSON.stringify(json)).then((res: any) => {
      if (res.success) {
        emit('submit')
      }
    })
  } else {
    ElMessage.error(t('请选择需要的项目'))
  }
  loading.value = false
}
const close = () => {
  emit('close')
}

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    onClose: close,
    width: "700px",
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('问卷调查')), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('感谢您使用它。 请帮助我们今后改进我们的服务。')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(questions), (v, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: v.title
              }, [
                (v.show())
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(v.title), 1),
                        _withDirectives(_createElementVNode("span", { class: "require-tip" }, _toDisplayString(_unref(t)('必需的')), 513), [
                          [_vShow, v.require]
                        ]),
                        _withDirectives(_createElementVNode("span", {
                          class: "fx-1",
                          style: {"text-align":"right","color":"#EB4545"}
                        }, _toDisplayString(_unref(t)('必填')), 513), [
                          [_vShow, v.require && v.propName]
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.options, (v2, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "option-item",
                          key: i
                        }, [
                          (v2.text)
                            ? (_openBlock(), _createBlock(_component_el_checkbox, {
                                key: 0,
                                modelValue: v2.checked,
                                "onUpdate:modelValue": ($event: any) => ((v2.checked) = $event),
                                label: v2.text
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_9, [
                            (v2.checked && 'custom' in v2)
                              ? (_openBlock(), _createBlock(_component_el_input, {
                                  key: 0,
                                  maxlength: "200",
                                  modelValue: v2.custom,
                                  "onUpdate:modelValue": ($event: any) => ((v2.custom) = $event),
                                  rows: 3,
                                  type: "textarea",
                                  placeholder: v2.placehodler ?? _unref(t)('请填写投诉内容')
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                              : _createCommentVNode("", true),
                            (v2.requireCustom === 'anim')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(t)('必填')), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128)),
                      _withDirectives(_createElementVNode("div", _hoisted_11, null, 512), [
                        [_vShow, i !== _unref(questions).length - 1]
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: valid,
              style: {"margin-bottom":"12px"},
              disabled: loading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('提交并关闭自动续费')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createElementVNode("span", {
              onClick: close,
              class: "btn"
            }, _toDisplayString(_unref(t)('继续保留自动续费')), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})